import moment, {Moment} from "moment";
import {Nil} from "./Types";


export const ACCOUNTANT_MONTH_PATTERN = 'YYYY-MM';

export const DATE_PATTERN = 'DD-MM-YYYY';
export const DATE_MASK = '__-__-____';


export const formatDate = (d: Moment | Date | Nil) => {
    return format(d, DATE_PATTERN);
}

export const formatMonth = (d: Moment | Nil) => {
    return format(d, ACCOUNTANT_MONTH_PATTERN);
}

export const format = (d: moment.Moment | Date | Nil, pattern: string) => {
    if (d) {
        //It's essential to create new instance of moment as previous one may hold old locale
        return moment(d.toISOString()).format(pattern)
    } else {
        return "";
    }
}

export const dateSetter = (date: Moment | undefined) => {
    if (date) {
        return date.toISOString()
    } else {
        return undefined;
    }
}

export const dateGetter = (date: string | undefined) => {
    if (date) {
        return moment(date)
    } else {
        return undefined;
    }
}